<template>
  <div class="sidebar-container">
    <p class="sidebar-title">TigerPan Lab</p>
    <el-menu
      default-active="1"
      background-color="#444"
      text-color="#fff"
      active-text-color="#ffd04b">
      <sidebar-item :routes="routes"/>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "@/components/SidebarItem";

export default {
  name: "AppSidebar",

  components: {SidebarItem},

  computed: {
    ...mapGetters([
      'routers'
    ]),

    routes() {
      return this.routers;
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 200px;
  height: 100vh;
  background-color: #444;

  .sidebar-title {
    font-size: 20px;
    font-family: Montserrat-SemiBold;
    color: #fff;
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppSidebar.vue